module.exports = __webpack_public_path__ + "static/media/AddToBookList.1ce62b82.png";